import { apiPharmaInstance } from 'utils/axios';
import { ResponseType } from './types';

export const getCommercialAgreements = async () => {
    return await apiPharmaInstance.get(`/api/commercial-agreements/`);
};

export const getCommercialAgreementsWithPagination = async (
    rows?: number,
    page?: number,
    value?: string,
): Promise<ResponseType<any>> => {
    let queryParams = '';
    if (!!rows) {
        queryParams += `rows=${rows}`;
    }
    if (!!page) {
        queryParams += `&page=${page}`;
    }
    if (!!value) {
        queryParams += `&filters[search]=${value}`;
    }
    return await apiPharmaInstance.get(`/api/commercial-agreements?${queryParams}`);
};

export const getCommercialAgreementById = async (id) => {
    return await apiPharmaInstance.get(`/api/commercial-agreements/${id}`);
};

export const updateAgreementsAll = async (data, id) => {
    return await apiPharmaInstance.post(`/api/commercial-agreements/${id}`, data);
};

export const updateAgreementsCustom = async (data, id) => {
    return await apiPharmaInstance.post(`/api/commercial-agreements/${id}`, data, {
        headers: { 'content-type': 'multipart/form-data' },
    });
};

// NEW EP ACP UPDATE
export const updateAgreements = async (data, id) => {
    return await apiPharmaInstance.post(`/api/commercial-agreements/${id}`, data, {
        headers: { 'content-type': 'multipart/form-data' },
    });
};

export const saveAgreementsAll = async (data) => {
    return await apiPharmaInstance.post('/api/commercial-agreements', data);
};

// NEW EP ACP CREATE
export const saveAgreementsCustom = async (data) => {
    return await apiPharmaInstance.post('/api/commercial-agreements', data, {
        headers: { 'content-type': 'multipart/form-data' },
    });
};

export const deleteAgreementById = async (id: number) => {
    return await apiPharmaInstance.delete(`/api/commercial-agreements/${id}`);
};

export const downloadFileEmail = async (queryId, id) => {
    return await apiPharmaInstance.get(`/api/commercial-agreements/${queryId}/list/${id}/download`);
};

export const agreementsValidate = async (data) => {
    return await apiPharmaInstance.post(`/api/commercial-agreements/validate`, data,{
        headers: { 'content-type': 'multipart/form-data' },
    })
}